import { render, staticRenderFns } from "./AuthInstructions.vue?vue&type=template&id=b34fd148&scoped=true&"
import script from "./AuthInstructions.vue?vue&type=script&lang=js&"
export * from "./AuthInstructions.vue?vue&type=script&lang=js&"
import style0 from "./AuthInstructions.vue?vue&type=style&index=0&id=b34fd148&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34fd148",
  null
  
)

export default component.exports